Vue.component('alerts-category', {
    delimiters: ['[[', ']]'],
    mixins: [eventHubMixin, languageMixin],
    data: () => {
      return {
        alerts: []
      } 
    },
    methods: {
      addAlert(category) {
        category.message = this.t('alerts:category', "Bravo vous venez d'améliorer votre")
        this.alerts.push(category);
        this.removeAlertTimeout();
      },
      addAlerts(list) {
        list.forEach((category_, index_) => {
          ((category, index) => {
            let to = setTimeout(() => {
              this.addAlert(category)
              clearTimeout(to);
            }, index * 400)
          })(category_, index_)        
        });
      },
      removeAlertTimeout() {
        let to = setTimeout(() => {
            this.alerts.shift()
            clearTimeout(to);
        }, 3000);
      }
    },
    mounted() {
      this.eventHub.$on('alerts:category:addone', (event) => {
        this.addAlert(event);
      })
      this.eventHub.$on('alerts:category:addlist', (event) => {
        this.addAlerts(event);
      })
    },
    template: `<ul class="alert-floating">
    <transition-group name="tsn-slide-fade" tag="li">
    <li class="alert" v-for="alert in alerts" v-bind:key="alert.id">
        <div class="flex-group">
            <span class="label-icon">[[alert.icon]]</span> <p>[[alert.message]] <span class="highlight" v-bind:style="{ color: alert.color }">[[alert.name]]</span></p>
        </div>
    </li>
    </transition-group>
</ul>` 
  })  